<template>
  <div>
    <loading :active.sync="isLoading" :is-full-page="fullPage" :loader="$store.state.spinerLoader"
      :color="$store.state.spinerColor"></loading>
    <vue-snotify></vue-snotify>
    <b-card>
      <b-row align-v="center" slot="header">
        <b-col cols="8">
          <h3 class="mb-0">Submit for Review</h3>
        </b-col>
      </b-row>

      <b-row>
        <b-col lg="2">
          <b-form inline>
            <label class="mr-sm-2" for="inline-form-custom-select-pref">Claim Type</label>
            <b-form-input disabled :value="proxyString(activeClaim)" placeholder="N/A" class="w-50"></b-form-input>
            <!-- :value="claimTypeValueStr(activeClaim)" -->
          </b-form>
        </b-col>
        <b-col lg="4">
          <b-form inline>
            <label class="mr-sm-2" for="inline-form-custom-select-pref">Taxation Center</label>
            <!-- <b-form-input
              disabled
              placeholder="N/A"
              class="w-50"
            ></b-form-input> -->

            <v-select placeholder="--Select--" class="w-50" label="name" :options="taxCenterOptions" v-model="taxCenter"
              v-on:input="changeTaxCenter" :reduce="(option) => option.id">
            </v-select>
          </b-form>
        </b-col>

        <b-col lg="3">
          <b-form inline>
            <label class="mr-sm-2" for="inline-form-custom-select-pref">Amended</label>
            <b-form-select placeholder="N/A" class="w-50" :options="amendedOptions" v-model="amendedSelect"
              @change="changeClaimType" :disabled="amendedChangeDisableCondition">

            </b-form-select>
          </b-form>
        </b-col>

        <b-col lg="3">
          <div class="">
            <b-button :disabled="extractTaxationBtnDisableCondition" variant="outline-success"
              @click="extractFinancials()">Extract Financials</b-button>
            <div class="label label-size text-muted">
              {{ extractLastUpdate() }}
            </div>
          </div>
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col lg="4">
          <b-row>
            <b-col lg="12">
              <b-form class="form-group float-right" inline>
                <label class="mr-sm-2" for="inline-form-custom-select-pref">Labour Specified</label>
                <b-form-input readonly :value="convertToThousandSeperators(financialData.labourSpecified)
                  " placeholder="N/A"></b-form-input>
              </b-form>
            </b-col>
            <b-col lg="12">
              <b-form class="form-group float-right" inline>
                <label class="mr-sm-2" for="inline-form-custom-select-pref">Labour Non-Specified</label>
                <b-form-input readonly :value="convertToThousandSeperators(
                  financialData.labourNonSpecified
                )
                  " placeholder="N/A"></b-form-input>
              </b-form>
            </b-col>
            <b-col lg="12">
              <b-form class="form-group float-right" inline>
                <label class="mr-sm-2" for="inline-form-custom-select-pref">Overhead</label>
                <b-form-input readonly :value="convertToThousandSeperators(financialData.overhead)"
                  placeholder="N/A"></b-form-input>
              </b-form>
            </b-col>
            <b-col lg="12">
              <b-form class="form-group float-right" inline>
                <label class="mr-sm-2" for="inline-form-custom-select-pref">Proxy</label>
                <b-form-input readonly :value="convertToThousandSeperators(financialData.proxy)"
                  placeholder="N/A"></b-form-input>
              </b-form>
            </b-col>
            <b-col lg="12">
              <b-form class="form-group float-right" inline>
                <label class="mr-sm-2" for="inline-form-custom-select-pref">Materials</label>
                <b-form-input readonly :value="convertToThousandSeperators(financialData.materials)"
                  placeholder="N/A"></b-form-input>
              </b-form>
            </b-col>
            <b-col lg="12">
              <b-form class="form-group float-right" inline>
                <label class="mr-sm-2" for="inline-form-custom-select-pref">Subcontracts</label>
                <b-form-input readonly :value="convertToThousandSeperators(financialData.subcontracts)
                  " placeholder="N/A"></b-form-input>
              </b-form>
            </b-col>
            <b-col lg="12">
              <b-form class="form-group float-right" inline>
                <label class="mr-sm-2" for="inline-form-custom-select-pref">IRAP or other Assistance</label>
                <b-form-input readonly :value="convertToThousandSeperators(
                  financialData.irapAndOtherAssistance
                )
                  " placeholder="N/A"></b-form-input>
              </b-form>
            </b-col>
            <b-col lg="12">
              <b-form class="form-group float-right" inline>
                <label class="mr-sm-2" for="inline-form-custom-select-pref">Prev. Yr Taxable Income</label>
                <b-form-input readonly :value="convertToThousandSeperators(
                  financialData.prevYrTaxableIncome
                )
                  " placeholder="N/A"></b-form-input>
              </b-form>
            </b-col>
          </b-row>
        </b-col>
        <b-col lg="4">
          <b-row>
            <b-col lg="12">
              <b-form class="form-group float-right" inline>
                <label class="mr-sm-2" for="inline-form-custom-select-pref">ITC Balance</label>
                <b-form-input readonly :value="convertToThousandSeperators(financialData.itcBalance)"
                  placeholder="N/A"></b-form-input>
              </b-form>
            </b-col>
            <b-col lg="12">
              <b-form class="form-group float-right" inline>
                <label class="mr-sm-2" for="inline-form-custom-select-pref">ITC</label>
                <b-form-input readonly :value="convertToThousandSeperators(financialData.itcTotal)"
                  placeholder="N/A"></b-form-input>
              </b-form>
            </b-col>
            <b-col lg="12">
              <b-form class="form-group float-right" inline>
                <label class="mr-sm-2" for="inline-form-custom-select-pref">ITC Refundable</label>
                <b-form-input readonly :value="convertToThousandSeperators(financialData.itcRefundable)
                  " placeholder="N/A"></b-form-input>
              </b-form>
            </b-col>
            <b-col lg="12">
              <b-form class="form-group float-right" inline>
                <label class="mr-sm-2" for="inline-form-custom-select-pref">ITC Non-Refundable</label>
                <b-form-input readonly :value="convertToThousandSeperators(financialData.itcNonRefundable)
                  " placeholder="N/A"></b-form-input>
              </b-form>
            </b-col>
            <b-col lg="12">
              <b-form class="form-group float-right" inline>
                <label class="mr-sm-2" for="inline-form-custom-select-pref">OITC</label>
                <b-form-input readonly :value="convertToThousandSeperators(financialData.oitc)"
                  placeholder="N/A"></b-form-input>
              </b-form>
            </b-col>
            <b-col lg="12">
              <b-form class="form-group float-right" inline>
                <label class="mr-sm-2" for="inline-form-custom-select-pref">ORDTC Elected</label>
                <b-form-input readonly :value="convertToThousandSeperators(financialData.ordtcElected)
                  " placeholder="N/A"></b-form-input>
              </b-form>
            </b-col>
            <b-col lg="12">
              <b-form class="form-group float-right" inline>
                <label class="mr-sm-2" for="inline-form-custom-select-pref">Other</label>
                <b-form-input readonly :value="convertToThousandSeperators(financialData.other)"
                  placeholder="N/A"></b-form-input>
              </b-form>
            </b-col>
            <b-col lg="12">
              <b-form class="form-group float-right" inline>
                <label class="mr-sm-2" for="inline-form-custom-select-pref">Total Eligible Expenditures</label>
                <b-form-input readonly :value="convertToThousandSeperators(
                  financialData.totalEligibleExpenditures
                )
                  " placeholder="N/A"></b-form-input>
              </b-form>
            </b-col>
          </b-row>
        </b-col>
        <b-col lg="4">
          <b-row v-if="false">
            <b-col lg="12">
              <b-button :disabled="generateT2TaxFileDisbleCheck" class="float-right" @click="generateT2TaxFile()" block
                variant="outline-success"><i class="fa-solid fa-file-csv pr-3"></i>Export Claim
                Financials</b-button>
              <label v-if="activeClaim && activeClaim.isT2TaxFileGenerated" class="label label-size text-muted">{{
                t2TaxFileGeneratedOn() }}</label>
            </b-col>
          </b-row>

          <b-row v-if="false" class="pt-5 mt-2" v-show="uploadTaxNativeFileShowCondition">
            <b-col lg="12">
              <div>
                <!-- <b-button
                  v-model="file1"
                  class="upload-outline"
                  placeholder="Upload Schedules PDF"
                  drop-placeholder="Drop file here..."
                  @click="$bvModal.show('bv-native-tax-upload-modal')"
                ></b-button> -->

                <b-button :disabled="taxNativeDisabledCondition" block variant="primary" class="float-right"
                  @click="$bvModal.show('bv-native-tax-upload-modal')">
                  <i class="fa-solid fa-upload"></i>
                  Upload Schedules PDF</b-button>
              </div>
            </b-col>
          </b-row>
          <b-row class="pt-5 mt-2" v-show="claimIsReadyToShowCondition">
            <b-col lg="12">
              <b-button block variant="warning" class="float-right" @click="claimIsReadyForView()"
                :disabled="readyToReviewDisabledCondition">
                <i class="fa-solid fa-circle-info"></i>
                <span v-if="activeClaim && activeClaim.internalReviewStatus < 4">Claim is ready for Review</span>
                <span v-if="activeClaim && activeClaim.internalReviewStatus == 4">Add files for review</span>
                <span v-if="activeClaim && activeClaim.internalReviewStatus == 5">Claim review completed</span>
              </b-button>
            </b-col>
            <div class="claimReviewInfo" v-if="activeClaim && activeClaim.internalReviewStatus == 4 && reviewInfo">
              <div class="text-center">Claim review info</div>
              <div>Current Reviewer: {{ reviewInfo.reviewName }}</div>

              <label v-for="(document) in reviewInfo.documents">
                {{ document.name }} <span class="reviewStatusApproved"
                  v-if="document.reviewStatus == 1">Approved</span><span class="reviewStatusRejected"
                  v-if="document.reviewStatus == 2">Rejected</span> {{ document.note }}
              </label>

            </div>
          </b-row>
        </b-col>
      </b-row>
    </b-card>

    <b-modal id="bv-native-tax-upload-modal" hide-footer>
      <template #modal-title>
        <h3>Upload Schedules PDF</h3>
      </template>
      <div class="d-block">
        <b-row>
          <b-col lg="10">
            <div class="form-group">
              <div>
                <b-form-file v-model="tax_native_file" variant="primary" placeholder="Choose a file or drop it here..."
                  drop-placeholder="Drop file here..."></b-form-file>
                <b-progress :value="tax_native_file_progress" :max="max" show-progress animated class="mt-2"
                  variant="warning" v-if="isUploading == 1" height="1.5rem"></b-progress>
              </div>
            </div>
          </b-col>
          <b-col lg="2">
            <b-button variant="" :disabled="isUploading == 1" @click="tax_native_file = null"><i class="fa fa-refresh"
                aria-hidden="true"></i>
            </b-button>
          </b-col>
        </b-row>
      </div>

      <div class="float-right mt-3">
        <b-button variant="primary" @click="uploadTaxNativeFile()"
          :disabled="!tax_native_file || isUploading == 1">Upload</b-button>
        <b-button variant="" @click="$bvModal.hide('bv-native-tax-upload-modal')">Cancel</b-button>
      </div>
    </b-modal>




    <b-modal centered :close-on-esc="false" :show-close="false" no-close-on-backdrop size="xl"
      id="selects-files-for-review" hide-footer>
      <template #modal-title>
        <h3>Select files for review</h3>
      </template>
      <DocumentExplorer ref="documentExplorer" v-if="!reviewObject.isSelectedFiles" :claim_id="claim_id"
        :client_id="client_id" :select_mode="true"></DocumentExplorer>
      <div v-else>
        Enter note for reviewer (optional)
        <b-form-textarea id="textarea" v-model="reviewObject.note" rows="3" max-rows="6"></b-form-textarea>
      </div>
      <div class="float-right mt-3">
        <b-button variant="primary" v-if="!reviewObject.isSelectedFiles"
          @click="selectedFilesForReview()">Next</b-button>
        <b-button variant="primary" v-else @click="submitFilesForReview()">Submit</b-button>
        <b-button variant="" @click="$bvModal.hide('selects-files-for-review')">Cancel</b-button>
      </div>
    </b-modal>

    <!-- Email Confirmation Modal -->
    <b-modal centered :close-on-esc="false" :show-close="false" no-close-on-backdrop size="sm"
      id="email-send-confirmation-internal-review" hide-footer hide-header>
      <b-row>
        <b-col cols="12">
          <div class="text-center mb-4">You're about to send an email to:</div>
          <div class="text-center mb-3 text-wrap-div">
            {{ emailString }}
          </div>
          <div class="text-center">
            <b-button variant="success" size="sm" class="pr-3 pl-3" @click="sendReadyForViewEmail()">Send</b-button>
            <b-button variant="warning" size="sm" class="pr-3 pl-3" @click="closeEmailConfirmBox()">Cancel</b-button>
          </div>
          <div class="float-right mt-5"></div>
        </b-col>
      </b-row>
    </b-modal>
    <!-- End Email Confirmation Modal -->
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import _ from "lodash";
import mixins from "./../../mixins/common.js";
import moment from "moment";
import DocumentExplorer from "@/components/DocumentExplorer/DocumentExplorer.vue";

export default {
  props: ["client_id", "claim_id"],
  mixins: [mixins],
  components: {
    DocumentExplorer
  },
  data() {
    return {
      tax_native_file: null,
      file1: null,
      financialData: [],
      isLoading: false,
      fullPage: true,
      isUploading: 0,
      value: 0,
      max: 100,
      amendedOptions: [
        { value: 0, text: "--Select--" },
        { value: 1, text: "Amended" },
        { value: 2, text: "Non-Amended" },
      ],
      amendedSelect: 0,
      emailString: "",
      taxCenter: "",
      taxCenterOptions: [],
      reviewObject: {
        isSelectedFiles: false,
        selectedFiles: [],
        note: ""
      },
      reviewInfo: {
        reviewName: "",
        documents: []
      },
      isReviewWorkflow: false
    };
  },
  watch: {
    activeClaim: function (newVal, oldVal) {
      if (this.activeClaim) {
        this.loadPreviousFinancialData();
        this.amendedSelect = this.activeClaim.claimType;
        this.taxCenter = this.activeClaim.gTaxCenter ? this.activeClaim.gTaxCenter.id : "";
        this.getClaimReviewInfo();

        this.isUserHasReviewWorkflow(this.activeClaim.id).then((data) => {
          this.isReviewWorkflow = data.data;
        });
      }
    },
  },
  methods: {
    ...mapActions("admin", [
      "extractFinancialsData",
      "generateT2TaxFileData",
      "getExtractedFinancialsData",
      "uploadTaxProgramNativeFile",
      "setClaimIsReadyForView",
      "updateClaimType",
      "sendReadyToReviewEmail",
      "getAllTaxCenters",
      "updateTaxCenter",
      "getClaimReviewInfoRequest",
      "isUserHasReviewWorkflow"
    ]),
    changeTaxCenter() {
      this.isLoading = true;
      let dataParams = {
        claimId: this.claim,
        taxCenter: this.taxCenter,
      };
      this.updateTaxCenter(dataParams).then((data) => {
        if (data.data.errors) {
        } else {
          this.$snotify
            .success(data.data.success.message, "Success!", {
              position: "centerTop",
            })
            .on("destroyed", () => { });
        }
        this.isLoading = false;
      });
    },
    changeClaimType() {
      this.isLoading = true;
      let dataParams = {
        claimId: this.claim,
        claimType: this.amendedSelect,
      };
      this.updateClaimType(dataParams).then((data) => {
        if (data.data.errors) {
        } else {
          this.activeClaim.claimType = this.amendedSelect;
          this.$snotify
            .success(data.data.message, "Success!", {
              position: "centerTop",
            })
            .on("destroyed", () => { });
        }
        this.isLoading = false;
      });
    },
    closeEmailConfirmBox() {
      this.$bvModal.hide("email-send-confirmation-internal-review");
    },
    selectedFilesForReview() {
      this.reviewObject.selectedFiles = this.$refs.documentExplorer.getSelectedFiles();
      if (this.reviewObject.selectedFiles.length > 0 && this.activeClaim.internalReviewStatus == 4) {
        this.submitFilesForReview();
      } else if (this.reviewObject.selectedFiles.length > 0) {
        this.reviewObject.isSelectedFiles = true;
      }
    },
    submitFilesForReview() {
      this.isLoading = true;

      let dataParams = {
        claimId: this.claim,
        selectedFiles: this.reviewObject.selectedFiles.map(x => x.fullName),
        note: this.reviewObject.note
      };

      this.setClaimIsReadyForView(dataParams).then((data) => {
        if (data) {
          this.$bvModal.hide("selects-files-for-review");
          this.getClaimReviewInfo();
          if (data.data && data.data && data.data.message) {
            this.$snotify
              .success(data.data.message, "Success!", {
                position: "centerTop",
              });
          }
        }
      });
      this.isLoading = false;
    },
    claimIsReadyForView() {
      this.reviewObject = {
        isSelectedFiles: false,
        selectedFiles: [],
        note: ""
      }
      this.$bvModal.show("selects-files-for-review");
    },
    sendReadyForViewEmail() {
      let claimParams = {
        claim_id: this.claim_id,
      };
      this.sendReadyToReviewEmail(claimParams).then((data) => {
        if (data.data && data.data.success && data.data.success.message) {
          this.$snotify
            .success(data.data && data.data.success.message, "Success!", {
              position: "centerTop",
            })
            .on("destroyed", () => {
              this.closeEmailConfirmBox();
            });
        }
        this.isLoading = false;
      });
    },
    uploadTaxNativeFile() {
      let formData = new FormData();
      formData.append("myFile", this.tax_native_file);
      formData.append("claim_id", this.claim);
      this.isUploading = 1;
      this.uploadTaxProgramNativeFile(formData).then((data) => {
        if (data.data.success) {
          this.activeClaim.nativeTaxFileStatus = true;
          this.$snotify
            .success(data.data.success.message, "Success!", {
              position: "centerTop",
            })
            .on("destroyed", () => { });
          this.$bvModal.hide("bv-native-tax-upload-modal");
        } else {
          this.$bvModal.hide("bv-native-tax-upload-modal");
        }
        this.isUploading = 0;
        this.tax_native_file_progress = 0;
      });
    },
    extractFinancials() {
      this.isLoading = true;
      let financeParams = {
        claim_id: this.claim,
      };
      this.extractFinancialsData(financeParams).then((data) => {
        if (data.data.errors) {
        } else {
          this.financialData = data.data;
          this.activeClaim.isFinancialExtracted = true;
          this.activeClaim.internalReviewStatus = 1;
          this.internal_review_class = this.internalReviewClassStr(1);
        }
        this.isLoading = false;
      });
    },
    loadPreviousFinancialData() {
      if (this.activeClaim && this.activeClaim.isFinancialExtracted) {
        this.isLoading = true;
        let financeParams = {
          claim_id: this.claim,
        };
        this.getExtractedFinancialsData(financeParams).then((data) => {
          if (data.data.errors) {
          } else {
            this.financialData = data.data;
          }
          this.isLoading = false;
        });
      } else {
        this.financialData = [];
      }
      this.isLoading = false;
    },
    generateT2TaxFile() {
      this.isLoading = true;
      let financeParams = {
        claim_id: this.claim,
      };
      this.generateT2TaxFileData(financeParams).then((data) => {
        if (data.data.errors) {
        } else {
          this.$snotify
            .success(data.data.message, "Success!", {
              position: "centerTop",
            })
            .on("destroyed", () => { });
          this.activeClaim.isT2TaxFileGenerated = true;

          this.activeClaim.t2TaxFileGeneratedOn = moment();
        }
        this.isLoading = false;
      });
    },
    extractLastUpdate() {
      if (this.financialData && this.financialData.updatedOn) {
        return (
          "Last Updated : " +
          moment(new Date(this.financialData.updatedOn)).format(
            "YYYY-MM-DD H:m"
          )
        );
      } else {
        return "";
      }
    },
    t2TaxFileGeneratedOn() {
      if (this.activeClaim && this.activeClaim.t2TaxFileGeneratedOn) {
        return (
          "File Generated : " +
          moment(new Date(this.activeClaim.t2TaxFileGeneratedOn)).format(
            "YYYY-MM-DD H:m"
          )
        );
      }
    },
    getClaimReviewInfo() {
      this.getClaimReviewInfoRequest(this.activeClaim.id).then((data) => {
        if (data.data) {
          this.reviewInfo = data.data;
          this.activeClaim.internalReviewStatus = data.data.internalReviewStatus;
          if (data && data.data && data.data.documents) {
            data.data.documents = data.data.documents.map(x => {
              return {
                name: x.name.replace("DocumentStore/", ""),
                reviewStatus: x.reviewStatus,
                note: x.note
              }
            });
          }
        }
      });
    }
  },
  computed: {
    amendedChangeDisableCondition() {
      let disableCheck = false;
      if (this.activeClaim && this.activeClaim.internalReviewStatus == 5) {
        disableCheck = true;
      }
      return disableCheck;
    },

    extractTaxationBtnDisableCondition() {
      let disableCheck = false;
      if (
        (this.activeClaim && this.activeClaim.internalReviewStatus == 5) ||
        (this.activeClaim && !this.activeClaim.proxy) ||
        !this.checkIfClaimHasPermission(this.activeClaim)
      ) {
        disableCheck = true;
      }
      return disableCheck;
    },

    uploadTaxNativeFileShowCondition() {
      let show = false;
      if (this.activeClaim && this.activeClaim.isFinancialExtracted) {
        show = true;
      }
      return show;
    },
    taxNativeDisabledCondition() {
      let disableCheck = false;
      if (this.activeClaim && this.activeClaim.internalReviewStatus == 5) {
        disableCheck = true;
      }
      return disableCheck;
    },
    readyToReviewDisabledCondition() {
      let disableCheck = false;
      if (
        ((this.activeClaim && this.activeClaim.internalReviewStatus == 5) ||
          (this.activeClaim && !this.activeClaim.isFinancialExtracted)) || !this.isReviewWorkflow
      ) {
        disableCheck = true;
      }
      return disableCheck;
    },
    claimIsReadyToShowCondition() {
      let show = false;
      if (
        this.activeClaim &&
        //this.activeClaim.nativeTaxFileStatus &&
        this.activeClaim.proxy &&
        this.activeClaim.industryType
      ) {
        show = true;
      }
      return show;
    },
    generateT2TaxFileDisbleCheck() {
      let disableCheck = false;
      if (
        (this.activeClaim && !this.activeClaim.isFinancialExtracted) ||
        (this.activeClaim && this.activeClaim.internalReviewStatus == 5)
      ) {
        disableCheck = true;
      }
      return disableCheck;
    },
    client: {
      get() {
        return this.$store.state.client;
      },
      set(val) {
        this.$store.state.client = val;
      },
    },
    claim: {
      get() {
        return this.$store.state.claim;
      },
      set(val) {
        this.$store.state.claim = val;
      },
    },
    activeClaim: {
      get() {
        return this.$store.state.activeClaim;
      },
      set(val) {
        this.$store.state.activeClaim = val;
      },
    },
    tax_native_file_progress: {
      get() {
        return this.$store.state.admin.tax_native_file_progress;
      },
      set(val) {
        this.$store.state.admin.tax_native_file_progress = val;
      },
    },
    internal_review_class: {
      get() {
        return this.$store.state.internal_review_class;
      },
      set(val) {
        this.$store.state.internal_review_class = val;
      },
    },
  },
  mounted() {
    //clear snotofy
    this.clearSnotifyMessages();
    if (
      this.$route.query.claim_id &&
      this.activeClaim &&
      this.activeClaim.isFinancialExtracted
    ) {
      let financeParams = {
        claim_id: this.$route.query.claim_id,
      };
      this.getExtractedFinancialsData(financeParams).then((data) => {
        if (data.data.errors) {
        } else {
        }
      });
    }

    this.getAllTaxCenters().then((data) => {
      if (data.data.errors) {
      } else {
        this.taxCenterOptions = data.data;
      }
    });
  },
};
</script>

<style scoped>
.label-size {
  font-size: 0.7rem;
  font-weight: 300;
  line-height: 1.7;
}

.text-wrap-div {
  word-break: break-word;
}

.claimReviewInfo {
  padding-left: 17.5px;
  padding-top: 10px;
  width: 100%;
}

.reviewStatusApproved {
  color: lightgreen;
}

.reviewStatusRejected {
  color: red;
}
</style>
